/* ═══════════════════════════════════════════════════════════════════════
   CRÉAPANEL — assets/cp-gamme.js
   GAMME — ÉPAISSEURS DISPONIBLES PAR DÉCOR
   Chargé par snippets/cp-decor-data.liquid (fiches produit uniquement).
   Source des données : window.CP_DECORS (snippets/cp-decor-data.liquid),
   lui-même lu dans le métachamp de variante custom.epaisseurs_disponibles_mm.
   les épaisseurs absentes du décor sont grisées (« indisponible dans ce décor ») ;
   si l'épaisseur choisie n'existe pas dans le nouveau décor, on bascule sur
     la plus proche en dessous (sinon la plus petite) et on le dit au client ;
   l'ajout au panier est refusé si l'épaisseur n'existe pas dans le décor,
     ou si aucune règle de collection n'a été trouvée (CFG_getEffectiveRules
     renvoie alors matchedCollectionId = 0 et des suppléments à 0 €).
    textes (T-EP-1 à 4) : « Marbre noir : 20 ou 40 mm
   seulement. », bouton « 60 mm — indisponible » nommé, message de bascule, refus
   d'ajout ; décor sans donnée : trace console ; contrôle decor_epaisseur dans cp-modele.
   Le moteur (configurator-main.js) n'est pas modifié : on enveloppe
   App.render et App.renderThicknessUI. Un rendu demandé avant le démarrage du
   moteur (sans dessin) est ignoré : il levait une TypeError à chaque chargement.
   ═══════════════════════════════════════════════════════════════════════*/
(function () {
  'use strict';

  function getApp() { try { return (typeof App !== 'undefined') ? App : window.App; } catch (e) { return window.App; } }
  function say(msg, type, ms) { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(msg, type, ms); }
  function norm(A, s) {
    if (A && typeof A.normalizeId === 'function') return A.normalizeId(s);
    return String(s || '').toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  /* Décor courant -> { name, thk:[mm…], c45, ref } ou null (aucune donnée = aucune restriction).
      décor sans donnée (métachamp custom.epaisseurs_disponibles_mm absent) → comportement inchangé,
     avec une trace console, une fois par décor.*/
  var traced = {};
  function currentDecor(A) {
    var map = window.CP_DECORS;
    if (!map || !A || !A.S || !A.S.variant) return null;
    for (var name in map) {
      if (!Object.prototype.hasOwnProperty.call(map, name)) continue;
      if (norm(A, name) === A.S.variant) {
        var d = map[name];
        var thk = String(d.thk || '').split(',').map(function (x) { return Number(String(x).trim()); })
          .filter(function (n) { return n > 0; });
        if (thk.length) return { name: name, thk: thk, c45: !!d.c45, ref: d.ref || '' };
      }
    }
    if (!traced[A.S.variant]) {
      traced[A.S.variant] = true;
      var sv = null; try { sv = A.getSelectedShopifyVariant && A.getSelectedShopifyVariant(); } catch (e) {}
      console.info('[cp-thk] décor « ' + ((sv && sv.title) || A.S.variant) + ' » sans épaisseurs (métachamp de variante custom.epaisseurs_disponibles_mm) : toutes les épaisseurs restent proposées');
    }
    return null;
  }
  /* « 20 ou 40 », « 12, 20 ou 40 » */
  function ou(list) { return list.length > 1 ? list.slice(0, -1).join(', ') + ' ou ' + list[list.length - 1] : String(list[0]); }
  window.CP_thkText = function (d) { return d ? d.name + ' : ' + ou(d.thk) + ' mm seulement.' : ''; };
  window.CP_currentDecor = function () { return currentDecor(getApp()); };

  function injectCss() {
    if (document.getElementById('cp-gamme-thk-css')) return;
    var st = document.createElement('style');
    st.id = 'cp-gamme-thk-css';                                   /*  cp-modele pose déjà un « cp-thk-css » (écarts de prix)*/
    st.textContent =
      '#thk-container label.cp-thk-na{opacity:.6;cursor:not-allowed}' +           /*  « indisponible » lisible, plus barré*/
      '.cp-thk-note{margin:.4rem 0 0;font-size:13px;line-height:1.4;color:#4b5563;flex-basis:100%}';   /* .8rem = 8 px (racine à 10 px) */
    document.head.appendChild(st);
  }

  /* Grise les épaisseurs absentes du décor ; corrige S.thk si besoin.
     notify=true : un message explique la bascule au client. */
  function applyThickness(A, notify) {
    var host = document.getElementById('thk-container');
    var decor = currentDecor(A);
    var allowed = decor ? decor.thk : null;
    if (host) {
      injectCss();
      var inputs = host.querySelectorAll('input[name="thk"]');
      var offered = [];
      Array.prototype.forEach.call(inputs, function (inp) {
        var mm = Number(inp.value);
        if (inp.dataset.cpBase === undefined) inp.dataset.cpBase = inp.disabled ? '1' : '0';
        var na = !!allowed && allowed.indexOf(mm) < 0;
        inp.disabled = (inp.dataset.cpBase === '1') || na;
        var lab = host.querySelector('label[for="' + inp.id + '"]');
        if (lab) { lab.classList.toggle('cp-thk-na', na); lab.removeAttribute('title'); }
        /* T-EP-2 : « indisponible » visible sous l'épaisseur (à la place de l'écart de prix de
           cp-modele, CP_thkDeltas) et nom accessible « 60 mm, indisponible pour Marbre noir »*/
        if (na) { inp.setAttribute('aria-disabled', 'true'); inp.setAttribute('aria-label', mm + ' mm, indisponible pour ' + decor.name); }
        else if (inp.dataset.cpBase !== '1') { inp.removeAttribute('aria-disabled'); inp.removeAttribute('aria-label'); }
        if (!na) offered.push(mm);
      });
      if (typeof window.CP_thkDeltas === 'function') window.CP_thkDeltas();
      var note = host.querySelector('.cp-thk-note');
      var missing = allowed ? Array.prototype.map.call(inputs, function (i) { return Number(i.value); })
        .filter(function (mm) { return allowed.indexOf(mm) < 0; }) : [];
      if (missing.length) {                                       /* T-EP-1 : « Marbre noir : 20 ou 40 mm seulement. » */
        if (!note) { note = document.createElement('p'); note.className = 'cp-thk-note'; host.appendChild(note); }
        note.textContent = window.CP_thkText(decor);
      } else if (note) note.remove();
      /* fiche technique : la ligne « Épaisseur » suit le décor (« 18 mm » pour un décor limité), texte du produit sinon */
      var spec = document.querySelector('.cp-specs .spec-item[data-key$="epaisseur"] .spec-value');
      if (spec) {
        if (spec.dataset.cpBase === undefined) spec.dataset.cpBase = spec.textContent.trim();
        var dispo = Array.prototype.map.call(inputs, function (i) { return Number(i.value); }).filter(function (mm) { return allowed && allowed.indexOf(mm) >= 0; });
        var st = missing.length && dispo.length ? ou(dispo) + ' mm' : spec.dataset.cpBase;
        if (spec.textContent !== st) spec.textContent = st;
      }

      var cur = Number(A.S.thk || 0);
      if (allowed && allowed.indexOf(cur) < 0 && offered.length) {
        var below = offered.filter(function (mm) { return mm <= cur; });
        var next = below.length ? Math.max.apply(null, below) : Math.min.apply(null, offered);
        A.S.thk = next;
        var target = host.querySelector('input[name="thk"][value="' + next + '"]');
        if (target) target.checked = true;
        if (notify) say(decor.name + ' n\'existe pas en ' + cur + ' mm : votre plan passe en ' + next + ' mm. Le prix est mis à jour.', 'info', 6000);   /* T-EP-3 */
      }
    }
    return allowed;
  }

  function wrap(A) {
    if (A.__cpThkWrapped) return;
    A.__cpThkWrapped = true;
    var origRender = A.render, origThkUI = A.renderThicknessUI;
    if (typeof origThkUI === 'function') {
      A.renderThicknessUI = function () {
        var r = origThkUI.apply(this, arguments);
        applyThickness(this, false);
        return r;
      };
    }
    if (typeof origRender === 'function') {
      A.render = function () {
        if (!this.svg) return;                                    /* moteur pas encore démarré (voir earlyGuard) */
        /* avant le rendu : S.thk doit déjà être une épaisseur vendable (prix et dessin) */
        try { applyThickness(this, true); } catch (e) { console.warn('[cp-thk]', e); }
        return origRender.apply(this, arguments);
      };
    }
    /* le premier rendu a pu avoir lieu avant l'enveloppe */
    try {
      var before = Number(A.S && A.S.thk || 0);
      applyThickness(A, false);
      if (A.S && Number(A.S.thk) !== before && typeof A.render === 'function') A.render();
    } catch (e) { console.warn('[cp-thk]', e); }
  }

  /* Le moteur démarre sur window.load, mais le script plein écran de custom-configV2 demande un rendu dès la
     première image : sans dessin (App.svg), clear levait une TypeError à chaque chargement. Depuis (ce
     fichier est différé), la garde est posée en ligne par cp-decor-data (CP_earlyGuard) ; ceci n'est qu'un repli.*/
  function earlyGuard(a) {
    if (!a || a.__cpEarly || typeof a.render !== 'function') return;
    a.__cpEarly = true;
    var r = a.render;
    a.render = function () { if (!this.svg) return; return r.apply(this, arguments); };
  }
  try {
    var d0 = Object.getOwnPropertyDescriptor(window, 'AppConfigurator');
    if (window.AppConfigurator) earlyGuard(window.AppConfigurator);
    else if (!d0 || d0.configurable) {
      var cur;
      Object.defineProperty(window, 'AppConfigurator', { configurable: true, enumerable: true,
        get: function () { return cur; },
        set: function (a) { cur = a; earlyGuard(a); } });
    }
  } catch (e) { console.warn('[cp-thk]', e); }

  /* Intertitres de gamme de la fenêtre Finition. Donnée : window.CP_GAMME (cp-decor-data : nom du décor -> libellé client
     de sa gamme, métachamp de variante custom.gamme). Les décors sont regroupés par gamme, la moins chère d'abord ; chaque
     groupe est précédé de « <gamme> — dès <prix> €/<unité> » : le plus bas prix des variantes disponibles de la gamme, au
     même calcul que le prix de l'en-tête (prix de la variante, en centimes, lu comme des euros par unité de vente).
     Décors sans gamme : à la fin, sans intertitre ; intertitre caché quand tous ses décors le sont. Sans donnée : rien. */
  var NB = ' ';
  function fmtPrix(c) { return String(Math.round(c)).replace(/\B(?=(\d{3})+(?!\d))/g, NB); }
  function intertitres() {
    var G = window.CP_GAMME, V = document.getElementById('variants-container'), P = window.__PRODUCT__;
    if (!G || !V || !P || !Object.keys(G).length) return false;
    var opts = Array.prototype.slice.call(V.querySelectorAll('.variant-opt'));
    if (!opts.length) return false;
    var nom = function (o) { var n = o.querySelector('.variant-name'); return n ? n.textContent.trim() : ''; };
    var mins = {};
    (P.variants || []).forEach(function (v) {
      var g = G[v.option1], c = Number(v.price);
      if (!g || v.available === false || !isFinite(c)) return;
      if (mins[g] == null || c < mins[g]) mins[g] = c;
    });
    var noms = Object.keys(mins).sort(function (a, b) { return mins[a] - mins[b]; });
    if (!noms.length) return false;
    if (!V.__cpGammes) {
      V.__cpGammes = true;
      if (!document.getElementById('cp-gamme-titre-css')) {
        var st = document.createElement('style'); st.id = 'cp-gamme-titre-css';
        st.textContent = '#variants-container .cp-gamme-titre{grid-column:1 / -1;margin:8px 0 0;font-size:13px;font-weight:600;line-height:1.35;color:#374151}' +
          '#variants-container .cp-gamme-titre:first-child{margin-top:0}#variants-container .cp-gamme-titre[hidden]{display:none}';
        document.head.appendChild(st);
      }
      var u = ((document.querySelector('.config-header-unit') || {}).textContent || '').split('/').pop().trim().toLowerCase() || 'ml';
      var frag = document.createDocumentFragment();
      noms.forEach(function (g) {
        var h = document.createElement('p'); h.className = 'cp-gamme-titre'; h.setAttribute('data-cp-gamme', g);
        h.textContent = g + ' — dès ' + fmtPrix(mins[g]) + NB + '€/' + u;
        frag.appendChild(h);
        opts.filter(function (o) { return G[nom(o)] === g; }).forEach(function (o) { frag.appendChild(o); });
      });
      opts.filter(function (o) { return noms.indexOf(G[nom(o)]) < 0; }).forEach(function (o) { frag.appendChild(o); });
      V.appendChild(frag);
    }
    Array.prototype.forEach.call(V.querySelectorAll('.cp-gamme-titre'), function (h) {
      var g = h.getAttribute('data-cp-gamme');
      h.hidden = !opts.some(function (o) { return G[nom(o)] === g && o.style.display !== 'none'; });
    });
    return true;
  }
  var gTries = 0, gTimer = setInterval(function () {
    if (document.querySelector('#variants-container .variant-opt') && window.__PRODUCT__) { clearInterval(gTimer); intertitres(); }
    else if (++gTries > 400) clearInterval(gTimer);
  }, 50);
  /* à chaque ouverture de la fenêtre Finition : les décors masqués (fermés) ont pu changer */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#bar-btn-variant')) setTimeout(intertitres, 0);
  }, true);
  window.CP_intertitres = intertitres;

  /* App est déclaré par configurator-main.js, chargé après ce fichier : on l'attend */
  var tries = 0;
  var timer = setInterval(function () {
    var A = getApp();
    if (A && A.S && typeof A.render === 'function' && document.getElementById('thk-container')) {
      clearInterval(timer); wrap(A);
    } else if (++tries > 400) clearInterval(timer);
  }, 50);

  /* Garde à l'ajout au panier : écoute sur window en capture, donc AVANT
     le gestionnaire du configurateur (document, capture). */
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#btn-add-cart');
    if (!btn) return;
    var A = getApp();
    var stop = function (msg) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      say(msg, 'error', 7000);
    };
    var noRule = false;
    try { noRule = (typeof CFG_getEffectiveRules === 'function') && Number(CFG_getEffectiveRules().matchedCollectionId || 0) === 0; } catch (err) {}
    if (noRule) {
      return stop('Ce produit ne peut pas encore être commandé en ligne. Écrivez-nous.');   /* L75 (lot « messages 1 », AUDIT Tour 597, point 5) */
    }
    if (A && A.S) {
      var decor = currentDecor(A);
      /* A-397 (AUDIT Tour 922) : boiserie (cp-etagere), le décor de la fiche est celui des panneaux, à leur épaisseur (18 mm) ;
         A.S.thk (38 mm) est celle des étagères */
      var bm = null; try { bm = typeof window.CP_boisModel === 'function' ? window.CP_boisModel() : null; } catch (err) {}
      var ep = bm ? Number(bm.epaisseur_mm) : Number(A.S.thk);
      if (decor && decor.thk.indexOf(ep) < 0) {
        return stop(decor.name + ' n\'existe pas en ' + ep + ' mm. Choisissez ' + ou(decor.thk) + ' mm, puis ajoutez au panier.');   /* T-EP-4 */
      }
    }
  }, true);
})();
